import { videoCallEntity } from '@/src/entities/video-call2'

export function init() {
  const store = videoCallEntity.model.useVideoCallStore()
  store.target = 'private'
}
